import { ScanLine } from 'lucide-react';

const EmptyStateGuide = ({
  icon: Icon = ScanLine,
  iconColor = '#6b5ce7',
  title,
  subtitle,
  ctaLabel,
  onCta,
}) => {
  return (
    <div
      style={{
        background: '#f9fafb',
        borderRadius: 8,
        padding: '14px 16px',
        border: '0.5px solid #e8e8e8',
      }}
      data-testid="empty-state-guide"
    >
      <div className="flex items-start gap-3">
        <Icon className="flex-shrink-0 mt-0.5" style={{ width: 16, height: 16, color: iconColor }} />
        <div className="flex-1">
          <p style={{ fontSize: 12, color: '#555555', margin: 0, fontWeight: 500 }}>{title}</p>
          {subtitle && (
            <p style={{ fontSize: 11, color: '#aaaaaa', margin: '4px 0 0', fontWeight: 400, lineHeight: 1.5 }}>
              {subtitle}
            </p>
          )}
          {ctaLabel && onCta && (
            <button
              onClick={onCta}
              style={{
                marginTop: 10,
                height: 28,
                padding: '0 12px',
                borderRadius: 6,
                border: `1px solid ${iconColor}`,
                background: 'transparent',
                color: iconColor,
                fontSize: 12,
                fontWeight: 500,
                cursor: 'pointer',
              }}
              data-testid="empty-state-cta"
            >
              {ctaLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmptyStateGuide;
